<template>
  <div>
    <div class="content d-flex flex-column mt-2" v-if="fields">
      <div class="row">
        <div class="col">
          <input-v
            v-model="projeto.tipo_projetoId"
            :valid.sync="fieldsComputed.tipo_projetoId.valid"
            :label="fieldsComputed.tipo_projetoId"            
            :editable="canEdit"
            :opts="opts"
          >
          </input-v>
        </div>        
      </div>
      <div class="row mt-n2">        
        <div class="col">
          <input-v
            v-model="projeto.troca_ppb"
            :valid.sync="fieldsComputed.troca_ppb.valid"
            :label="fieldsComputed.troca_ppb"
            :editable="canEdit"
          >
          </input-v>
        </div>
        <div class="col">
          <input-v
            v-model="projeto.alcance"
            :valid.sync="fieldsComputed.alcance.valid"
            :label="fieldsComputed.alcance"
            :editable="canEdit"
            :opts="opts"
          >
          </input-v>
        </div>
      </div>
      <div class="row mt-n2">
        <div class="col">
          <input-v
            v-model="projeto.inovacao"
            :valid.sync="fieldsComputed.inovacao.valid"
            :label="fieldsComputed.inovacao"            
            :opts="opts"
          >
          </input-v>
        </div>
      </div>
      <div class="row mt-n2">
        <div class="col">
          <input-v
            v-model="projeto.inovacao_desenvolvimento"
            :valid.sync="fieldsComputed.inovacao_desenvolvimento.valid"
            :label="fieldsComputed.inovacao_desenvolvimento"            
            :opts="opts"
          >
          </input-v>
        </div>
      </div>
      <div class="row mt-n2">
        <div class="col">
          <input-v
            v-model="projeto.possui_publicacoes"
            :valid.sync="fieldsComputed.possui_publicacoes.valid"
            :label="fieldsComputed.possui_publicacoes"
            :editable="canEdit"
          >
          </input-v>
        </div>
      </div>
      <div class="row align-items-center mt-n2">        
        <div class="col" v-if="projeto.possui_publicacoes === 'Sim'">
          <input-v
            v-model="projeto.qtde_publicacoes"
            :valid.sync="fieldsComputed.qtde_publicacoes.valid"
            :label="fieldsComputed.qtde_publicacoes"
            :editable="canEdit"
          ></input-v>
        </div>
        <div class="col">          
          <input-v
            v-model="projeto.area_aplicacaoId"
            :label="fieldsComputed.area_aplicacaoId"
            :opts="opts"
          >
          </input-v>
        </div>
      </div>
      <div class="row mt-n2">
        <div class="col">
          <input-v
            v-model="projeto.decreto"
            :valid.sync="fieldsComputed.decreto.valid"
            :label="fieldsComputed.decreto"
            :editable="canEdit"
            :opts="opts"
          ></input-v>
        </div>     
      </div>
      <!-- <div class="row mt-n2">
        <div class="col">
          <input-v
            v-model="projeto.keyword_li"
            :valid.sync="fieldsComputed.keyword_li.valid"
            :label="fieldsComputed.keyword_li"
            :editable="canEdit"
          ></input-v>
        </div>     
      </div> -->
      <div class="propriedade-intelectual">
        <div class="header row mt-5 p-2">
          <div class="header col">
            <h3 class="h3 bold">Geração de propriedade intelectual</h3>
          </div>
          <div class="action col-auto">
            <button @click="handleCreatePropriedadeIntelectual" :style="`color: ${primaryColor}`" class="px-2">+ Adicionar propriedade intelectual</button>
          </div>
        </div>
        <div class="content d-flex flex-column" v-if="projeto.propriedade_intelectual && projeto.propriedade_intelectual.length > 0">     
          <div v-for="(resp, index) in projeto.propriedade_intelectual" :key="index" :class="`mb-4 border border-black p-3 rounded ${radioClass}`">
            <div class="row align-items-center">
              <div class="col">
                <div class="row">
                  <div class="col-12 mb-2">
                    <label class="font-weight-bold d-block">Tipo da propriedade intelectual:</label>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" :id="`patente-${index}`" :name="`tipo-${index}`" value="patente" class="custom-control-input" v-model="resp.tipo">
                      <label class="custom-control-label" :for="`patente-${index}`">Patente</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" :id="`direitos_autorais-${index}`" :name="`tipo-${index}`" value="direitos_autorais" class="custom-control-input" v-model="resp.tipo">
                      <label class="custom-control-label" :for="`direitos_autorais-${index}`">Direitos Autorais</label>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <label class="font-weight-bold">Descrição:</label>
                      <input v-model="resp.descricao" type="text" placeholder="Descrição" :class="['form-control', inputClass]" />
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <label class="font-weight-bold">Registro do pedido:</label>
                      <input v-model="resp.registro" type="text" placeholder="Registro do pedido" :class="['form-control', inputClass]" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <label class="font-weight-bold">Data do pedido:</label>
                      <input v-model="resp.data" type="date" :class="['form-control', inputClass]" />
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <label class="font-weight-bold">País:</label>
                      <input v-model="resp.pais" type="text" placeholder="País" :class="['form-control', inputClass]" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <label class="font-weight-bold d-block">Situação:</label>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" :id="`pedido-${index}`" :name="`situacao-${index}`" value="pedido" class="custom-control-input" v-model="resp.situacao">
                      <label class="custom-control-label" :for="`pedido-${index}`">Pedido</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" :id="`concedido-${index}`" :name="`situacao-${index}`" value="concedido" class="custom-control-input" v-model="resp.situacao">
                      <label class="custom-control-label" :for="`concedido-${index}`">Concedido</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-auto">
                <button @click="removerPropriedadeIntelectual(index)" class="btn btn-link text-danger p-0">
                  <v-icon color="red">mdi-delete</v-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <span class="form-text p-2">Nenhuma propriedade intelectual cadastrada.</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import fields from '../LIEnquadrados.fields';
import { isStrictProject } from "@/helpers/projectValidators";
import { mapGetters } from "vuex";
import { UserTypeEnum } from "@/core/enums/user-types";

export default {
  props: {
    projeto: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true,
      default: false
    },
    canEditStatus: {
      type: Boolean,
      required: true,
      default: false
    },
    isClient: {
      type: Boolean,
      required: true,
      default: false
    },
    cliente: {
      type: Object,
      required: true
    },
    hasAccessPlurianual: {
      type: Boolean,
      required: true,
      default: false
    },
    opts: {
      type: Object,
      required: true,
      default: function() {
        return {};
      }
    }
  },
  components: {
    'input-v': () => import('@/components/input-v.vue'),
  },
  data() { 
    return {
      possuiPublicacoes: false,
      fields,
    }
  },
  computed: {
    fieldsComputed: function() {
      const fields = cloneDeep(this.fields.classificacao);
      const isStrict = isStrictProject(this.projeto);

      return fields.reduce(
        (acc, field) => {
          if (!isStrict) {
             field.rules = (field.rules || []).filter(r => r.rule !== 'required');
          }
          return { ...acc, [field.key]: field }
        },
        {}
      );
    },
    ...mapGetters(["user"]),
    primaryColor() {
       const user = this.user || {};
       const { tipo_usuario } = user;
       const isClient = [UserTypeEnum.GERENCIAL_CLIENTE, UserTypeEnum.COLABORADOR].includes(tipo_usuario);
       return isClient ? 'rgba(11, 84, 86, 0.9)' : '#1c1c44';
    },
    radioClass() {
      const user = this.user || {};
      const { tipo_usuario } = user;
      const isClient = [UserTypeEnum.GERENCIAL_CLIENTE, UserTypeEnum.COLABORADOR].includes(tipo_usuario);
      return isClient ? 'radio-client' : 'radio-internal';
    },
    inputClass() {
      const user = this.user || {};
      const { tipo_usuario } = user;
      const isClient = [UserTypeEnum.GERENCIAL_CLIENTE, UserTypeEnum.COLABORADOR].includes(tipo_usuario);
      return isClient ? 'custom-input-client' : 'custom-input';
    }
  },
  methods: {
     handleCreatePropriedadeIntelectual() {
      if (!this.projeto.propriedade_intelectual) {
        this.$set(this.projeto, 'propriedade_intelectual', []);
      }
      this.projeto.propriedade_intelectual.push({        
        tipo: null,
        descricao: null,
        registro: null,
        data: null,
        situacao: null,
        pais: null,
      });    
    },
    removerPropriedadeIntelectual(index) {
      this.projeto.propriedade_intelectual.splice(index, 1);
    },
  },
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {}
}
</script>

<style scoped>
.custom-input-client:focus {
  border-color: rgba(11, 84, 86, 0.9);
  box-shadow: 0 0 0 0.2rem rgba(11, 84, 86, 0.25);
  outline: none
}
.custom-input-client {
  border-color: #ced4da;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.custom-input:focus {
  border-color: #1C1C44; 
  box-shadow: 0 0 0 0.2rem rgba(40, 42, 167, 0.25);
  outline: none
}
.custom-input {
  border-color: #ced4da;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.radio-client >>> .custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: rgba(11, 84, 86, 0.9);
  background-color: rgba(11, 84, 86, 0.9);
}

.radio-client >>> .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(11, 84, 86, 0.25);
}

.radio-internal >>> .custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #1c1c44;
  background-color: #1c1c44;
}

.radio-internal >>> .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(40, 42, 167, 0.25);
}
</style>